import React from 'react';
// import styles from 'routes/adminMobile/pages/AdminMobileStats.module.css';
import styles from 'routes/adminMobile/components/AdminMobileWeekSaleBest.module.css';
import AdminMobileContentBox from './common/AdminMobileContentBox';
import VerticalFlex from 'layouts/flex/VerticalFlex';
import FlexChild from 'layouts/flex/FlexChild';
import HorizontalFlex from 'layouts/flex/HorizontalFlex';
import { mainPadd2, pageEH2FontSize, pageEH3FontSize, registerGap2 } from '../constraints/AdminConst';
import P from 'components/P';
import backIcon from 'routes/vendorRe/images/back_icon.png';
import AdminMobileEmptyMsg from './common/AdminMobileEmptyMsg';

const AdminMobileWeekSaleBest = ({ products }) => {
    

    if (!products || products.length === 0) {
        return (
            <VerticalFlex>
                <FlexChild padding={mainPadd2}>
                    <AdminMobileEmptyMsg />
                </FlexChild>
            </VerticalFlex>
        );
    }

    return (
        <AdminMobileContentBox>
            <VerticalFlex>
                <FlexChild>
                    <div className={styles.borderBottom}>
                        <HorizontalFlex>
                            <FlexChild>
                                <P size={pageEH2FontSize}>주간 판매량 BEST</P>
                            </FlexChild>
                            <FlexChild justifyContent="flex-end">
                                <img className={styles.moveIcon} src={backIcon} alt='이동 아이콘' />
                            </FlexChild>
                        </HorizontalFlex>
                    </div>
                </FlexChild>
                <FlexChild>
                    {/* 반복 구간 */}
                    {products && products.map((product, index) => (
                        <div key={index} className={styles.borderBottom2}>
                            <HorizontalFlex gap={registerGap2}>
                                <FlexChild justifyContent="center" width="auto">
                                    <img className={styles.productImg} src={product.productImageUrl} alt='상품 이미지' />
                                </FlexChild>
                                <FlexChild>
                                    <VerticalFlex gap={registerGap2}>
                                        <FlexChild alignItems="flex-start">
                                            <P size={pageEH3FontSize}>{product.productName}</P>
                                        </FlexChild>
                                        <FlexChild alignItems="flex-start">
                                            <HorizontalFlex>
                                                <FlexChild>
                                                    <P size={pageEH3FontSize}>
                                                        {product.productSalesPrice ? product.productSalesPrice.toLocaleString() : 0}
                                                    </P>
                                                </FlexChild>
                                            </HorizontalFlex>
                                        </FlexChild>
                                    </VerticalFlex>
                                </FlexChild>
                                <FlexChild width="auto">
                                    <P weight={700} size={pageEH3FontSize} padding="0px 1.5rem 0px 0px">
                                        {product.totalQuantity ? product.totalQuantity.toLocaleString() : 0}
                                    </P>
                                </FlexChild>
                            </HorizontalFlex>
                        </div>
                    ))}
                    {/* 반복 구간 */}
                </FlexChild>
            </VerticalFlex>
        </AdminMobileContentBox>
    );
};

export default AdminMobileWeekSaleBest;